import { SimpleSpinner } from 'src/components';
import type { CartHistoryData } from 'src/types';
import { CartsDisplayListItem } from './CartsDisplayListItem';

type Props = {
  cartsList:
    | {
        carts: CartHistoryData[];
        pageParam: number;
      }[]
    | undefined;
  fetchingNextPage: boolean;
};

/**
 * Broken down into smaller components to make for
 * easier view changing between list and grid view.
 * See ./reusables for the smaller components.
 */
export const CartsDisplayList = ({ cartsList, fetchingNextPage }: Props) => {
  return (
    <div className='overflow-y-hidden overflow-x-scroll md:overflow-x-hidden'>
      {cartsList!.map((group, i) => (
        <ul key={i}>
          {group.carts.map((cart) => (
            <CartsDisplayListItem key={cart.cart.id} cart={cart} />
          ))}
        </ul>
      ))}

      {fetchingNextPage && (
        <div className='mx-auto w-fit py-6'>
          <SimpleSpinner
            customWidth='w-12'
            customHeight='h-12'
            customPosition='block'
          />
        </div>
      )}
    </div>
  );
};
